module.exports = __webpack_public_path__ + "img/img.310cb75f.png";